export const GET_BOOKINGS_RESPONSE = 'GET_BOOKINGS_RESPONSE';
export const GET_BOOKING_RESPONSE = 'GET_BOOKING_RESPONSE';
export const ADD_NEW_BOOKING_RESPONSE = 'ADD_NEW_BOOKING_RESPONSE';
export const UPDATE_EXISTING_BOOKING_RESPONSE = 'UPDATE_EXISTING_BOOKING_RESPONSE';

export const API_CALL_BEGIN = 'API_CALL_BEGIN';
export const API_CALL_ERROR = 'API_CALL_ERROR';
